import { StatsElementFilterInternalName } from '../../../../../shared/entities/stats-element/enums/StatsElementGridFilterName';

export const PROFITABLE_VS_UNPROFITABLE_AVAILABLE_LINK_FILTERS = [
  StatsElementFilterInternalName.ProfitableEbitda,
  StatsElementFilterInternalName.ProfitableNetIncome,
  StatsElementFilterInternalName.ProfitableFreeCashFlow,
];
